<template>
  <div class="home-page home-one">
    <LayoutsHeader />
    <main class="home-page__content">
      <HomeBanner />
      <HomeBenefits />
      <HomeTopCourses />
      <HomeFeatured />
      <HomeClient />
      <HomeFaq />
      <AchiveGoals />
    </main>
    <HomeFooter />
  </div>
</template>
<script>
import LayoutsHeader from "@/views/layouts/layouts-header.vue";
import HomeBanner from "./home-banner.vue";
import HomeBenefits from "./home-benefits.vue";
import HomeTopCourses from "./home-top-courses.vue";
import HomeFeatured from "./home-featured.vue";
import HomeClient from "./home-client.vue";
import AchiveGoals from "./achive-goals.vue";
import HomeFaq from "./home-faq.vue";
import HomeFooter from "./home-footer.vue";

export default {
  components: {
    LayoutsHeader,
    HomeBanner,
    HomeBenefits,
    HomeTopCourses,
    HomeFeatured,
    HomeClient,
    AchiveGoals,
    HomeFaq,
    HomeFooter,
  },
};
</script>
